import * as React from "react";
import styled from "@emotion/styled";

import { NavItem } from "../Text";
import { Colors } from "../../Themes";

interface IFormCheckboxCont {
  small: any;
}

const FormCheckboxCont = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  height: ${(props: IFormCheckboxCont) => (props.small ? "40px" : "50px")};
  padding: ${(props: IFormCheckboxCont) =>
    props.small ? "0 10px 20px 10px" : "10px"};
`;

const Input = styled.input`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  display: none;
`;

interface ITextCont {
  active: any;
}

const TextCont = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  color: ${Colors.semiBlack};
  transform-origin: 50% 0;
  transform-style: preserve-3d;
  background: ${Colors.whiteSmoke};
  transform: ${(props: ITextCont) =>
    props.active
      ? "rotateX(90deg) translateY(-22px)"
      : "rotateX(0deg) translateY(0)"};
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  &::before {
    left: 0;
    top: 100%;
    width: 100%;
    height: 100%;
    color: white;
    display: flex;
    border-radius: 4px;
    position: absolute;
    align-items: center;
    justify-content: center;
    transform-origin: 50% 0;
    content: attr(data-hover);
    transform: rotateX(-90deg);
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    background: ${(props: ITextCont) =>
      props.active ? Colors.cmmsDarkBlue : Colors.whiteSmoke};
  }
`;

interface IFormCheckboxLabel {
  noShadow: any;
  htmlFor?: any;
  active?: any;
}

const FormCheckboxLabel = styled.label`
  width: 100%;
  height: 100%;
  align-items: center;
  position: relative;
  justify-content: center;
  box-shadow: ${(props: IFormCheckboxLabel) =>
    props.noShadow ? "none" : "0 2px 4px rgba(0, 0, 0, 0.1)"};
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  &:hover {
    cursor: pointer;
  }
`;

interface IProps {
  label: string;
  name: string;
  checked: any;
  onChange: any;
  htmlFor: any;
  value?: any;
  small?: any;
  noShadow?: any;
  inlineStyling: any;
}

export default class FormCheckbox extends React.Component<IProps> {
  render() {
    const {
      label,
      name,
      checked,
      onChange,
      htmlFor,
      value,
      small,
      noShadow,
      inlineStyling
    } = this.props;
    return (
      <FormCheckboxCont small={small} style={inlineStyling}>
        <Input
          id={htmlFor}
          type="checkbox"
          name={name}
          value={value}
          hidden={false}
          onChange={onChange}
        />
        <FormCheckboxLabel
          noShadow={noShadow}
          htmlFor={htmlFor}
          active={checked}
        >
          <TextCont active={checked} data-hover={label}>
            <NavItem pointer={true}>{label}</NavItem>
          </TextCont>
        </FormCheckboxLabel>
      </FormCheckboxCont>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/FormElements/FormCheckbox.tsx